import { useDispatch, useSelector } from "react-redux";
import ButtonAHSF from "../../../Components/ButtonAHSF";
import TableAHSF from "../../../Components/TableAHSF";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

const FollowingApplicationEval = (porps) => {
  const dispatch = useDispatch();
  const [popUpBodyStatus, setPopUpBodyStatus] = useState(false);
  const arrayDataCheckBoks = useSelector(
    (state) => state.arrayDataCheckBoks.arrayDataCheckBoks["tasksList"]
  );
  const navigate = useNavigate();
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
  const UserInfo = useSelector((state) => state.UserInfo.UserInfo);
  const RequestAccessor = [
    {
      KeyName: "applicationNumber",
      ShowStatus: true,
      NmaeColumn: " رقم الطلب",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "",
        keyValueName: "",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },

    {
      KeyName: "applicantfullName",
      ShowStatus: true,
      NmaeColumn: "الاسم الكامل",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "",
        keyValueName: "",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "fieldName",
      ShowStatus: true,
      NmaeColumn: " الحقل ",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "",
        keyValueName: "",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "subjectName",
      ShowStatus: true,
      NmaeColumn: "  الموضوع",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "",
        keyValueName: "",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "mainTaskStatus",
      ShowStatus: true,
      NmaeColumn: "  حالة تحكيم الطلب",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "",
        keyValueName: "",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "mainTaskMark",
      ShowStatus: true,
      NmaeColumn: " مجموع علامة التحكيم",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "",
        keyValueName: "",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "evalfullName",
      ShowStatus: true,
      NmaeColumn: "اسم المحكم",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "",
        keyValueName: "",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "subTaskMark",
      ShowStatus: true,
      NmaeColumn: " مجموع علامة التحكيم",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "",
        keyValueName: "",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "shortList",
      ShowStatus: true,
      NmaeColumn: "  القائمة القصيرة",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "",
        keyValueName: "",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "reasonDescription",
      ShowStatus: true,
      NmaeColumn: "  توضيح السبب",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "",
        keyValueName: "",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "subTaskStatus",
      ShowStatus: true,
      NmaeColumn: " حالة التحكيم",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "",
        keyValueName: "",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
  ];

  const RequestsManagerBtns = [
   
    {
      Click: async (e) => {
        const result = JSON.parse(e.target.value)?.applicationInformationId;

        console.log(result, "sssswdwdwffefssssdwdwdwdwd");
        window.open(
          `/ResearchersAward/manager/ViewApplication/ApplicationInformation/` +
            result,
          "_blank"
        );
      },
      content: "",
      className: "bi bi-view-list",
      id: "editBtn",
      title: "عرض الطلب",
      ShowStatus: true,
      margedBtn:true
    },
  ];
const RequestsManagerBtnsLast = [
    {
      Click: async (e) => {
        console.log(e.target.value, "ddddddc");
        let value = JSON.parse(e.target.value).subTaskId;
        window.open(
          `/ResearchersAward/manager/evaluation/ApplicationByEvaluator/${value}`,
          "_blank"
        );
      },
      content: "",
      className: "bi bi-eye-fill",
      id: "editBtn",
      title: "عرض التحكيم",
      ShowStatus: true,
    },
   
  ];
  const RequestsManagerColumns = [];
  // send to read props popup
  const PopupOPjectData = {
    isPopupOpenStatus: popUpBodyStatus,

    isPopupOpenFunction: () => {},
    componentBody: <div></div>,

    title: "",
    maxWidth: "40%",
    maxHeight: "40%",
    idssss: "SecondarySectors",
  };

  return (
    <>
      <TableAHSF
        culomEdite={culomEdite}
        URL={`api/Evaluator/GetTasksEvalutor`}
        mergeColumns={[
          "applicationNumber",
          "applicantfullName",
          "fieldName",
          "subjectName",
          "mainTaskStatus",
          "mainTaskMark",
        ]}
        mergeCondition={(row, rowIndex) => rowIndex === 0} 
        dataRedux={arrayDataCheckBoks}
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable={"الطلبات"}
        selectRowNumber={true}
        checkBoksColumName="اختيار"
        sort={true}
        pagination={true}
        AppStatus={true}
        tableBtn={false}
        sortTable={true}
        arrayNameSort={["applicationNumber"]}
        search={true}
        trueText="نعم"
        falseText="لا"
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        checkBoks={false}
        total={false}
        arrayButton={RequestsManagerBtns}
        showActionButtonLast={true}
        arrayButtonLast={RequestsManagerBtnsLast}
        ArrayNameDataColum={RequestsManagerColumns}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"معلومات الطلب"}
      />
    </>
  );
};

export default FollowingApplicationEval;
